import { render, staticRenderFns } from "./inquiryBillsList.vue?vue&type=template&id=2d7d57f9&"
import script from "./inquiryBillsList.vue?vue&type=script&lang=js&"
export * from "./inquiryBillsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "inquiryBillsList.vue"
export default component.exports